import React, { useState } from "react";

const DownloadModal = ({ onClose, title, allInOneLink, dropboxLinks = [] }) => {
  const [copiedMessageIndex, setCopiedMessageIndex] = useState(null);

  const handleCopyLink = (text, index) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedMessageIndex(index);
        setTimeout(() => setCopiedMessageIndex(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  return (
    <div className="assets-modal-overlay" onClick={onClose}>
      <div
        className="assets-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Download Modal Header */}
        <div className="assets-modal-header">
          <div className="assets-modal-title-wrapper">
            <h2 className="assets-modal-title">{title}</h2>
            <svg
              onClick={onClose}
              className="assets-modal-close-button"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
            >
              <path
                d="M16 1L1 16"
                stroke="#474747"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M1 1L16 16"
                stroke="#474747"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <a href={allInOneLink} target="_blank" rel="noopener noreferrer">
            <button className="assets-modal-downloadall-button">
              Download All
            </button>
          </a>
        </div>

        {/* Download Table */}
        <div>
          <table className="assets-modal-table">
            {/* Download Table Header */}
            <thead>
              <tr className="assets-modal-table-header-row">
                <th className="assets-modal-table-header-text-filename">
                  File Name
                </th>
                <th className="assets-modal-table-header-text-download-copy">
                  Download/Copy
                </th>
              </tr>
            </thead>
            {/* Download Table Body */}
            <tbody>
              {dropboxLinks.map((item, index) => {
                if (!item.url) return null; // Skip rendering this row if url is missing

                return (
                  <tr key={index} className="assets-modal-table-body-row">
                    <td>
                      <div className="assets-file-name-cell">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M2.29759 0.591797C1.68823 0.591797 1.10383 0.842609 0.672949 1.28906C0.242067 1.73551 0 2.34102 0 2.97239V13.3605C0 13.9918 0.242067 14.5973 0.672949 15.0438C1.10383 15.4902 1.68823 15.7411 2.29759 15.7411H13.9944C14.6038 15.7411 15.1882 15.4902 15.6191 15.0438C16.0499 14.5973 16.292 13.9918 16.292 13.3605V5.56941C16.292 4.93804 16.0499 4.33252 15.6191 3.88607C15.1882 3.43962 14.6038 3.18881 13.9944 3.18881H7.86194C7.60785 3.18876 7.36249 3.09274 7.17183 2.91872L5.2736 1.18565C4.85412 0.802977 4.31441 0.59185 3.75552 0.591797H2.29759Z"
                            fill="url(#paint0_linear_2619_1232)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_2619_1232"
                              x1="6.6839"
                              y1="-7.19925"
                              x2="5.78721"
                              y2="6.64754"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#02316B" />
                              <stop offset="1" stopColor="#58B2FF" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span className="assets-modal-table-body-text">
                          {item.name}
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="assets-icon-cell">
                        <div className="assets-download-tooltip-wrapper">
                          {/* Download Icon */}
                          <div className="assets-icon-box">
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                style={{ cursor: "pointer" }}
                              >
                                <path
                                  d="M9.51595 7.61022L10.7201 6.36366C10.9226 6.16076 11.1939 6.04837 11.4755 6.0507C11.7572 6.05303 12.0267 6.16988 12.226 6.3761C12.4253 6.58232 12.5385 6.86139 12.5411 7.15322C12.5437 7.44505 12.4357 7.72628 12.2401 7.93634L9.20121 11.085C9.10168 11.1887 8.98335 11.2711 8.85301 11.3272C8.72268 11.3834 8.58291 11.4123 8.44175 11.4123C8.30059 11.4123 8.16083 11.3834 8.03049 11.3272C7.90016 11.2711 7.78182 11.1887 7.68229 11.085L4.64339 7.93634C4.54365 7.83285 4.46457 7.71003 4.41065 7.57488C4.35673 7.43973 4.32902 7.2949 4.32912 7.14865C4.32922 7.00241 4.35712 6.85762 4.41123 6.72255C4.46533 6.58748 4.54459 6.46477 4.64446 6.36143C4.74434 6.2581 4.86288 6.17615 4.99331 6.12028C5.12375 6.06441 5.26353 6.03571 5.40468 6.03582C5.54582 6.03592 5.68557 6.06483 5.81593 6.12089C5.94629 6.17695 6.06472 6.25906 6.16445 6.36255L7.36755 7.61022V1.33176C7.36755 1.03657 7.48073 0.753471 7.68218 0.544742C7.88363 0.336013 8.15686 0.21875 8.44175 0.21875C8.72665 0.21875 8.99987 0.336013 9.20133 0.544742C9.40278 0.753471 9.51595 1.03657 9.51595 1.33176V7.61022ZM1.99656 13.5748H14.8869C15.1718 13.5748 15.4451 13.6921 15.6465 13.9008C15.848 14.1095 15.9611 14.3926 15.9611 14.6878C15.9611 14.983 15.848 15.2661 15.6465 15.4748C15.4451 15.6836 15.1718 15.8008 14.8869 15.8008H1.99656C1.71167 15.8008 1.43844 15.6836 1.23699 15.4748C1.03554 15.2661 0.922363 14.983 0.922363 14.6878C0.922363 14.3926 1.03554 14.1095 1.23699 13.9008C1.43844 13.6921 1.71167 13.5748 1.99656 13.5748Z"
                                  fill="#A6A5A3"
                                />
                              </svg>
                            </a>
                          </div>
                          <div className="assets-download-tooltip">
                            <span className="assets-download-tooltip-text">
                              Download Files
                            </span>
                          </div>
                        </div>

                        <div className="assets-download-tooltip-wrapper">
                          {/* Copy Icon */}
                          <div className="assets-icon-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleCopyLink(item.url, index)}
                            >
                              <path
                                d="M16 6.36079C15.9913 6.28125 15.9745 6.2029 15.9498 6.12706V6.04915C15.9106 5.95959 15.8569 5.87762 15.7911 5.80676L10.7782 0.612729C10.7098 0.544532 10.6307 0.48891 10.5442 0.448251C10.5193 0.444333 10.494 0.444333 10.469 0.448251C10.384 0.398235 10.2903 0.365889 10.1933 0.353027H6.8096C6.14484 0.353027 5.50731 0.626641 5.03726 1.11368C4.56721 1.60071 4.30313 2.26127 4.30313 2.95004V3.81571H3.46764C2.80289 3.81571 2.16536 4.08933 1.69531 4.57636C1.22525 5.0634 0.961182 5.72396 0.961182 6.41273V15.0694C0.961182 15.7582 1.22525 16.4188 1.69531 16.9058C2.16536 17.3928 2.80289 17.6665 3.46764 17.6665H10.1515C10.8163 17.6665 11.4538 17.3928 11.9239 16.9058C12.3939 16.4188 12.658 15.7582 12.658 15.0694V14.2038H13.4935C14.1583 14.2038 14.7958 13.9302 15.2658 13.4431C15.7359 12.9561 16 12.2955 16 11.6068V6.36079ZM10.987 3.30497L13.1509 5.54706H11.8225C11.6009 5.54706 11.3884 5.45585 11.2317 5.29351C11.0751 5.13116 10.987 4.91098 10.987 4.68139V3.30497ZM10.987 15.0694C10.987 15.299 10.899 15.5192 10.7423 15.6816C10.5856 15.8439 10.3731 15.9351 10.1515 15.9351H3.46764C3.24606 15.9351 3.03355 15.8439 2.87687 15.6816C2.72018 15.5192 2.63216 15.299 2.63216 15.0694V6.41273C2.63216 6.18314 2.72018 5.96295 2.87687 5.80061C3.03355 5.63826 3.24606 5.54706 3.46764 5.54706H4.30313V11.6068C4.30313 12.2955 4.56721 12.9561 5.03726 13.4431C5.50731 13.9302 6.14484 14.2038 6.8096 14.2038H10.987V15.0694ZM14.329 11.6068C14.329 11.8363 14.241 12.0565 14.0843 12.2189C13.9276 12.3812 13.7151 12.4724 13.4935 12.4724H6.8096C6.58801 12.4724 6.3755 12.3812 6.21882 12.2189C6.06213 12.0565 5.97411 11.8363 5.97411 11.6068V2.95004C5.97411 2.72045 6.06213 2.50027 6.21882 2.33792C6.3755 2.17558 6.58801 2.08437 6.8096 2.08437H9.31606V4.68139C9.31606 5.37016 9.58013 6.03072 10.0502 6.51775C10.5202 7.00479 11.1578 7.2784 11.8225 7.2784H14.329V11.6068Z"
                                fill="#A6A5A3"
                              />
                            </svg>
                          </div>
                          <div className="assets-download-tooltip">
                            <span className="assets-download-tooltip-text">
                              Copy Link
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {/* Copy Feedback Message */}
          {copiedMessageIndex !== null && (
            <div className="copy-feedback-message">
              Link copied successfully
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadModal;
